export default __webpack_public_path__ + "static/media/Poppins-Bold.80260454.svg";